import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b9628ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-p-1 edit-form-container" }
const _hoisted_2 = { class: "t2 p-mb-4 p-mt-3 title-field" }
const _hoisted_3 = { class: "container-switch p-mb-5" }
const _hoisted_4 = { class: "t3 medium p-mb-2 title-field" }
const _hoisted_5 = { class: "p1 p-mb-4 description-field" }
const _hoisted_6 = { class: "p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-ml-2 switch-placeholder" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "switchLine" }, null, -1))
const _hoisted_9 = { class: "t3 p-mb-3 title-field" }
const _hoisted_10 = { class: "p1 text-light-gray p-mb-3 description-field" }
const _hoisted_11 = { class: "p-mb-5" }
const _hoisted_12 = { class: "count_message" }
const _hoisted_13 = { class: "t3 p-mb-3 title-field" }
const _hoisted_14 = { class: "p1 text-light-gray p-mb-3 description-field" }
const _hoisted_15 = {
  key: 0,
  class: "error-msj"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "p-mb-5" }
const _hoisted_18 = { class: "p-d-flex" }
const _hoisted_19 = { class: "container-file" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "container-file__fileName" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "t3 p-mb-3 title-field" }
const _hoisted_25 = { class: "p1 text-light-gray p-mb-3 description-field" }
const _hoisted_26 = {
  key: 1,
  class: "error-msj"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "social-networks p-mb-5" }
const _hoisted_29 = { class: "professional-description" }
const _hoisted_30 = { class: "t3 p-mb-3 title-field" }
const _hoisted_31 = {
  key: 0,
  class: "p1 text-light-gray p-mb-3 description-field"
}
const _hoisted_32 = { class: "p-d-flex p-jc-end p-ai-center button__group p-mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_input_wrapper = _resolveComponent("input-wrapper")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_input_text = _resolveComponent("input-text")!
  const _component_profile_languages = _resolveComponent("profile-languages")!
  const _component_profile_goals = _resolveComponent("profile-goals")!
  const _component_terms_modal = _resolveComponent("terms-modal")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('editProfile.showTalent.title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('editProfile.showTalent.titleSwitch')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('editProfile.showTalent.descriptionSwitch')), 1),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_InputSwitch, {
            modelValue: _ctx.state.showTalent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.showTalent) = $event)),
            onChange: _ctx.switchTalent
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('editProfile.showTalent.placeholder')), 1)
        ])
      ]),
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('editProfile.bio.title')), 1),
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('editProfile.bio.description')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_input_wrapper, {
          label: _ctx.questions.bio.label,
          inputId: _ctx.questions.bio.name,
          error: _ctx.$t( ((_ctx.validations.bio || { $errors: [] }).$errors[0] || { $message: '' }).$message, { minCharAllowed: _ctx.charAllowed.min, maxCharAllowed: _ctx.charAllowed.max } )
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Textarea, {
              rows: "5",
              cols: "30",
              class: _normalizeClass({
            'input-error': ((_ctx.validations.bio || { $errors: [] }).$errors[0] || { $message: undefined }).$message
          }),
              modelValue: _ctx.state.bio,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.bio) = $event)),
              id: _ctx.questions.bio.name,
              placeholder: _ctx.$t('editProfile.bio.placeholder')
            }, null, 8, ["class", "modelValue", "id", "placeholder"]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.state.bio.length || 0) + " / " + _toDisplayString(_ctx.charAllowed.max), 1)
          ]),
          _: 1
        }, 8, ["label", "inputId", "error"])
      ]),
      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('editProfile.cv.title')), 1),
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('editProfile.cv.description')), 1),
      (_ctx.showCVError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("img", {
              class: "p3",
              src: require('@/assets/icons/pi-icon-alert-red.svg')
            }, null, 8, _hoisted_16),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('editProfile.cv.incomplete')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, [
            (_ctx.infoCV)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/icons/Light_FileDoc.svg'),
                  alt: "doc icon"
                }, null, 8, _hoisted_20))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.infoCV), 1),
            (_ctx.infoCV)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/icons/Light_CheckCircle.svg'),
                  alt: "doc icon"
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeCV && _ctx.removeCV(...args))),
            class: "delete-buton"
          }, [
            _createElementVNode("img", {
              src: require('@/assets/icons/Trash.svg'),
              alt: "delete icon"
            }, null, 8, _hoisted_23)
          ])
        ]),
        _createVNode(_component_FileUpload, {
          ref: "fileUpload",
          mode: "basic",
          customUpload: true,
          name: "cv",
          accept: ".pdf",
          maxFileSize: 10000000,
          onUploader: _ctx.onUpload,
          auto: true,
          chooseLabel: _ctx.$t('editProfile.cv.attachButton')
        }, null, 8, ["onUploader", "chooseLabel"])
      ]),
      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t('editProfile.socialNetworks.title')), 1),
      _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.$t('editProfile.socialNetworks.description')), 1),
      (_ctx.showSocialError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("img", {
              class: "p3",
              src: require('@/assets/icons/pi-icon-alert-red.svg')
            }, null, 8, _hoisted_27),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('editProfile.socialNetworks.incomplete')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions.socialNetworks.manyQuestions, (subQuestion) => {
          return (_openBlock(), _createElementBlock("div", {
            key: subQuestion.name
          }, [
            _createElementVNode("div", null, [
              _createVNode(_component_input_wrapper, {
                label: subQuestion.label,
                inputId: subQuestion.name,
                error: _ctx.$t( ((_ctx.validations[subQuestion.name] || { $errors: [] }).$errors[0] || { $message: '' }).$message )
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_text, {
                    id: subQuestion.name,
                    name: subQuestion.name,
                    modelValue: _ctx.state[subQuestion.name],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.state[subQuestion.name]) = $event),
                    placeholder: subQuestion.placeholder,
                    onKeypress: _ctx.turnOffSocialError,
                    onBlur: _ctx.turnOffSocialError,
                    onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                  }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue", "placeholder", "onKeypress", "onBlur"])
                ]),
                _: 2
              }, 1032, ["label", "inputId", "error"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('editProfile.professionalInfo.title')), 1),
        (_ctx.user.country !== 'br')
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.$t('editProfile.professionalInfo.description')), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_profile_languages, {
          ref: "languagesComponent",
          showLanguagesError: _ctx.showLanguagesError,
          onSwitchTalent: _ctx.switchTalent
        }, null, 8, ["showLanguagesError", "onSwitchTalent"]),
        _createVNode(_component_profile_goals)
      ]),
      _createVNode(_component_terms_modal, {
        displayModal: _ctx.displayModal,
        onCloseModal: _ctx.closeModal,
        onPublishTalent: _ctx.handlePublish
      }, null, 8, ["displayModal", "onCloseModal", "onPublishTalent"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      (!!_ctx.questions.buttons.cancel)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            onClick: _ctx.handleCancel,
            label: _ctx.$t('editProfile.buttons.cancel'),
            disabled: _ctx.loadingSubmit,
            class: "secondary p-mr-2"
          }, null, 8, ["onClick", "label", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        onClick: _ctx.handleSubmit,
        label: _ctx.$t('editProfile.buttons.submit'),
        loading: _ctx.loadingSubmit,
        disabled: 
        _ctx.showExpertiseError ||
        _ctx.showLanguagesError ||
        _ctx.showSkillError ||
        _ctx.showSocialError ||
        _ctx.validations.errors ||
        _ctx.showCVError ||
        _ctx.loadingSubmit
      ,
        class: "primary"
      }, null, 8, ["onClick", "label", "loading", "disabled"])
    ])
  ], 64))
}